import { useMutation } from '@tanstack/react-query';
import { CreateAppNotification, DeleteNotifications, UpdateAppNotification } from '../../../Api/appnotifications';

export const useMutateCreateAppNotification = () =>
  useMutation({
    mutationFn: (data) => CreateAppNotification(data),
  });

export const useMutateEditAppNotification = () =>
  useMutation({
    mutationFn: ({ id, data }) => UpdateAppNotification(id,data),
  });


export const useMutateDeleteNotifications = () =>
  useMutation({
    mutationFn: (data) => DeleteNotifications(data),
  });
